// Application host: iorder-frontend/.k8s/deploy.yml + deploy workflow.
// Registration route: iorder-frontend/src/routes/public/index.ts.
export const APP_URL = "https://app.iorder.com.br/";
export const SIGNUP_URL = new URL("create-account", APP_URL).href;
